import { border, shadows } from 'src/components/foundations/tokens';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Container = styled.div<{ width?: string }>`
  position: relative;
  display: inline-flex;
  width: ${(props) => props.width || 'auto'};
`;

export const InnerContainer = styled.div`
  display: flex;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  gap: 10px;
  align-items: center;
  margin-right: 8px;
`;

export const SelectedCount = styled.span`
  color: ${({ theme }) => theme.atlas.semantic.color.action.primary.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
`;

export const DropdownChevronIcon = styled.div<{ $menuIsOpen: boolean }>`
  transform: ${(props) => (props.$menuIsOpen ? '' : 'rotate(-180deg)')};
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  font-size: 24px;
`;

export const FilterSelectDropDownContainer = styled.div<{
  $menuIsOpen: boolean;
  $size: 'small' | 'medium' | 'large';
  $zIndex?: number;
}>`
  ${(props) => {
    let top = '40px';
    switch (props.$size) {
      case 'small':
        top = '36px;';
        break;
      case 'medium':
        top = '48px;';
        break;
      case 'large':
        top = '64px;';
        break;
    }
    return {
      visibility: props.$menuIsOpen ? 'visible' : 'hidden',
      position: 'absolute',
      top: top,
      left: 0,
      width: '100%',
      background: props.theme.atlas.semantic.color.surface.default,
      display: 'flex',
      zIndex: props.$zIndex ?? 'inherit',
      borderRadius: border.radius.sm + 'px',
      boxShadow: shadows.sizes.medium,
      flexDirection: 'column',
    };
  }}
`;

export const CheckboxItemStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  &:hover {
    background-color: ${({ theme }) =>
      theme.atlas.semantic.color.action.secondary.hoverFill};
  }
`;
